import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({ 
  isVisible, 
  title = 'Confirm Action',
  message, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel',
  onConfirm, 
  onCancel,
  type = 'warning' // 'warning', 'danger', 'info'
}) => {
  if (!isVisible) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <div className="confirmation-modal-backdrop" onClick={handleBackdropClick}>
      <div className={`confirmation-modal confirmation-modal--${type}`}>
        <div className="confirmation-modal__header">
          <h3 className="confirmation-modal__title">{title}</h3>
        </div>
        
        <div className="confirmation-modal__body">
          <p className="confirmation-modal__message">{message}</p>
        </div>
        
        <div className="confirmation-modal__footer">
          <button
            className="confirmation-modal__button confirmation-modal__button--cancel"
            onClick={onCancel}
          >
            {cancelText}
          </button>
          <button
            className={`confirmation-modal__button confirmation-modal__button--confirm confirmation-modal__button--${type}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
